module.exports = __webpack_public_path__ + "img/background.8d97337e.png";